import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../shared/shared.module';
import { InputTextModule } from '../../public-api';
import { InputCheckboxComponent } from './input-checkbox.component';

@NgModule({
  declarations: [InputCheckboxComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
  ],
  exports: [InputCheckboxComponent],
})
export class InputCheckboxModule {}
